
var rxInstance = {

  createNew: function () {
    var ins = {}

    ins.option = {
      onCb: function () {}
    }

    ins.setCb = function (cb) {
      ins.option.onCb = cb
    }

    ins.call = function () {
      ins.option.onCb()
    }
    return ins
  }
}

const rx = rxInstance.createNew()

export default rx
